import { useQuery } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import {
  GetApiV1TenantsIdUsersParams,
  TenantUserResponsePaginationItemsContainer,
} from 'src/types/rest/tenant';

interface UseTenantUsersProps extends GetApiV1TenantsIdUsersParams {
  itemsPerPage: number;
  pageIndex: number;
  tenantId?: string;
}

export const useTenantUsers = ({
  itemsPerPage,
  pageIndex,
  query,
  tenantId,
}: UseTenantUsersProps) => {
  const queryParams = {
    itemsPerPage: itemsPerPage.toString(),
    pageIndex: pageIndex.toString(),
    query: query ? query.toString() : '',
  };

  const {
    tenancy: { apiHost },
  } = useAppConfig();

  const searchParams = new URLSearchParams(queryParams);

  return useQuery({
    enabled: !!tenantId,
    queryFn: () =>
      apiRequest<TenantUserResponsePaginationItemsContainer>({
        url: `${apiHost}/tenants/${tenantId}/users?${searchParams.toString()}`,
      }),
    queryKey: ['tenant', tenantId, 'users', queryParams],
  });
};
